/**
 * withSystemSettings
 * HOC for wrapping the provided component with CommerceChannelsProvider
 */

import React from 'react'

import CommerceChannelsProvider from './commerce-channels-provider'

export default function withCommerceChannels(WrappedComponent) {
  return function CommerceChannelsProviderHOC(props) {
    return (
      <CommerceChannelsProvider {...props}>
        <WrappedComponent {...props} />
      </CommerceChannelsProvider>
    )
  }
}
